export default __webpack_public_path__ + "8d288dc2cac3959e7bca146007fb4eed.png";